import hero1 from "../assets/serviceimg1.png";
// import hero2 from "../assets/services1_hero.svg";
import mainImg from "../assets/mainImg.jpeg";
import smallImg from "../assets/smallImg.jpeg";
import ground from "../assets/ground.jpeg"
import adani from "../assets/andani.jpeg"
import hero2 from "../assets/hero_svg.png"
import adani_solar from "../assets/adani-solar.webp"
import meena from "../assets/meena.png"
import OND from "../assets/OND Meena.png"
import nathu from "../assets/nathu.jpeg"
import Manyapura from "../assets/Manyapura.png" 
import Rohru from "../assets/Rohru Shimla 800kW.png"
import Sainj from "../assets/Sainj Shimla 550 kW.png"
import Manyapura1 from "../assets/Manyapura1.png"
import Nathukanagla from "../assets/Nathu ka nagla.png"
import Jasingpura from "../assets/jaisingpura site .png"
import palwal from "../assets/Palwal adani.jpeg"
import paras_glass_waree from "../assets/paras glass waree.jpeg"
import FIROZABAD_GLASS_SHELL from "../assets/FIROZABAD GLASS SHELL.jpeg"
import rooftop_ferozabad from "../assets/mainImg.jpeg" 
import trader from '../assets/general traders.jpeg'
import firozabad_1500 from '../assets/smallImg.jpeg'
import durges_1500 from '../assets/durges_1500.jpeg'
import mukul from '../assets/nathu.jpeg'
import rgi from '../assets/farukhi Glass Industries.jpeg'
import Tauru from '../assets/Adani Logistics - Tauru.jpg'
const projectsData = [
  {
    slug: "pm-kusum-c-project-jasingpura",
    title: "PM KUSUM-C Project – Jasingpura | 5.2 MW Ground Mounted Solar Project",
    date: "16 Dec 2025",
    cardImage: Jasingpura ,
    heroImage: Jasingpura,
    fullDescription:
      "The Jasingpura facility in Rajasthan is part of the PM KUSUM-C initiative, featuring a 5.2 MW ground-mounted solar power plant. This large-scale on-grid solar system is designed to provide reliable and sustainable electricity, contributing to renewable energy adoption and reducing dependence on conventional power sources.The project uses ground-mounted solar panels, optimized for maximum sunlight exposure and long-term efficiency. Our team executed a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar energy system.This project demonstrates the successful implementation of government-backed renewable energy programs and highlights the commitment to sustainable power generation in Rajasthan.",

    solarSection: {
      titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Project Name: PM KUSUM-C Project – Jasingpura",
        "Project Location: Jasingpura, Rajasthan",
        "Project Capacity: 5.2 MW",
        "Installation Type: Ground Mounted Solar Power Plant",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "adani-logistics-talaja",
    title: "Adani Logistics Ltd – Taloja | 150 kW Rooftop Solar Project",
    date: "16 Dec 2025",
    cardImage: palwal,
    heroImage: palwal,
    fullDescription:
      "Adani Logistics Ltd’s facility in Taloja, Maharashtra is implementing clean energy solutions with the installation of a 150 kW rooftop solar power plant. This on-grid solar system ensures reliable electricity, reduces operational costs, and minimizes the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, engineered for optimal sunlight exposure, durability, and long-term performance. Our team provided a complete turnkey solution, including design, engineering, supply, installation, and commissioning, resulting in a fully operational and efficient solar energy system.This project highlights Adani Logistics Ltd’s commitment to sustainability and green energy adoption in logistics operations.",

    solarSection: {
      titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Adani Logistics Ltd",
        "Project Location: Taloja, Maharashtra",
        "Project Capacity: 150 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "adani-logistics-tauru",
    title: "Adani Logistics Ltd – Tauru | 500 kW Rooftop Solar Project",
    date: "16 Dec 2025",
    cardImage: Tauru,
    heroImage: Tauru,
    fullDescription:
      "Adani Logistics Ltd’s facility in Tauru, Haryana is advancing its renewable energy initiatives with the installation of a 500 kW rooftop solar power plant. This on-grid solar system provides reliable electricity, reduces operational energy costs, and lowers the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, designed for optimal sunlight exposure, durability, and long-term performance. Our team executed a complete turnkey solution, including design, engineering, supply, installation, and commissioning, delivering a fully functional and efficient solar energy system.This project highlights Adani Logistics Ltd’s commitment to sustainable and environmentally responsible logistics operations.",

    solarSection: {
      titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Adani Logistics Ltd",
        "Project Location: Tauru, Haryana",
        "Project Capacity: 500 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"

      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },
  {
    slug: "KCC-OND-Meena-2.232MWp-Ground-Mounted-Solar-Project",
    title: "KCC - OND Meena-2.232MWp || Ground Mounted Solar Project",
    date: "16 Dec 2025",
    cardImage: OND,
    heroImage: OND,
    fullDescription:
      "KCC's OND Meena facility is being powered sustainably through a 2.232 MWp ground-mounted solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation uses a robust ground-mounted structure, engineered for optimal sunlight exposure, safety, and long-term durability. Our team provides a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power setup.This project exemplifies KCC’s proactive approach to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: Ground Mounted ",
        "Project Location: OND Meena",
        "Project Capacity: 2.232 MWp",
        "Installation Type: Ground-Mounted Solar Power Plant",
        "Mounting Structure: Robust Ground-Mounted Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },


   {
    slug: "KCC-OND-Nathu-Ka-Nagla-3.084MWp-Ground-Mounted-Solar-Project",
    title: "KCC - Nathu Ka Nagla-3.084 MWp || Ground Mounted Solar Project",
    date: "16 Dec 2025",
    cardImage: Nathukanagla,
    heroImage: Nathukanagla,
    fullDescription:
      "KCC's Nathu Ka Nagla facility is being powered sustainably through a 3.084 MWp ground-mounted solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation utilizes a robust ground-mounted structure, engineered for optimal sunlight exposure, safety, and long-term durability. Our team delivers a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power setup.This project reflects KCC’s strong commitment to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: Nathu",
        "Project Location: Nathu Ka Nagla ",
        "Project Capacity: 3.084 MWp",
        "Installation Type: Ground-Mounted Solar Power Plant",
        "Mounting Structure: Robust Ground-Mounted Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },



   {
    slug: "KCC-OND-Manyapura-3.024MWp-Ground-Mounted-Solar-Project",
    title: "KCC - Manyapura -3.024 MWp || Ground Mounted Solar Project",
    date: "16 Dec 2025",
    cardImage: Manyapura1,
    heroImage: Manyapura1,
    fullDescription:
      "KCC's Manyapura facility is being powered sustainably through a 3.024 MWp ground-mounted solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation utilizes a robust ground-mounted structure, engineered for optimal sunlight exposure, safety, and long-term durability. Our team delivers a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power setup.This project reflects KCC’s strong commitment to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: KCC-OND-Manyapura",
        "Project Location: Manyapura",
        "Project Capacity: 3.024 MWp",
        "Installation Type: Ground-Mounted Solar Power Plant",
        "Mounting Structure: Robust Ground-Mounted Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  // {
  //   slug: "adani-logistics-palwal",
  //   title: "Adani Logistics Ltd – Palwal | 250 kW Rooftop Solar Project",
  //   date: "16 Dec 2025",
  //   cardImage: ground,
  //   heroImage: hero2,
  //   fullDescription:
  //     "Adani Logistics Ltd’s facility in Palwal, Haryana is adopting renewable energy with the installation of a 250 kW rooftop solar power plant. This on-grid solar system ensures reliable electricity supply, optimizes energy costs, and reduces the facility’s carbon footprint.The solar panels are installed on a tin shade rooftop structure, engineered for maximum sunlight exposure, durability, and long-term performance. Our team delivered a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar energy system.This project demonstrates Adani Logistics Ltd’s commitment to sustainability and green energy adoption in logistics operations.",

  //   solarSection: {
  //     titleLine1: "Join the Solar Revolution",
  //     titleLine2: "with Savorka",
  //     coverLabel: "Project Specifications",
  //     coveragePoints: [
  //       "Client Name: Adani Logistics Ltd",
  //       "Project Location: Palwal, Haryana",
  //       "Project Capacity: 250 kW",
  //       "Installation Type: Rooftop Solar Power Plant",
  //       "Mounting Structure: Tin Shade Rooftop Structure",
  //       "System Type: On-Grid Solar System",
  //       "Project Status: Ongoing",
  //       "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
  //     ],
  //     yearsText: "9+ YEARS",
  //     experienceText: "Experience",
  //     mainImage: mainImg,
  //     smallImage: smallImg
  //   }
  // },

  {
    slug: "mukul-overseas-mainpuri",
    title: "Mukul Overseas Pvt Ltd – Mainpuri | 800 kW Rooftop Solar Project",
    date: "16 Dec 2025",
    cardImage: mukul,
    heroImage: mukul,
    fullDescription:
      "Mukul Overseas Pvt Ltd’s facility in Mainpuri, Uttar Pradesh is transitioning to clean energy with the installation of an 800 kW rooftop solar power plant. This on-grid solar system is designed to provide reliable electricity, reduce energy costs, and minimize the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, engineered for maximum sunlight exposure, durability, and long-term performance. Our team delivered a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and optimized solar energy system.This project reflects Mukul Overseas Pvt Ltd’s commitment to sustainable operations and renewable energy adoption in industrial facilities.",

    solarSection: {
      titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Mukul Overseas Pvt Ltd",
        "Project Location: Mainpuri, Uttar Pradesh",
        "Project Capacity: 800 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "paras-glass-ware-firozabad",
    title: "Paras Glass Ware Pvt Ltd – Firozabad | 450 kW Rooftop Solar Project",
    date: "16 Dec 2025",
    cardImage: paras_glass_waree,
    heroImage: paras_glass_waree,
    fullDescription:
      "Paras Glass Ware Pvt Ltd’s facility in Firozabad is adopting renewable energy with the installation of a 450 kW rooftop solar power plant. This on-grid solar system is designed to provide consistent electricity, optimize energy costs, and reduce the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, engineered for optimal sunlight exposure, durability, and long-term efficiency. Our team provided a complete turnkey solution, including design, engineering, supply, installation, and commissioning, delivering a fully operational and efficient solar energy system.This project highlights Paras Glass Ware Pvt Ltd’s commitment to sustainable operations and green energy adoption in industrial facilities.",

    solarSection: {
      titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Paras Glass Ware Pvt Ltd",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 450 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "firozabad-glass-shell-industries",
    title: "Firozabad Glass Shell Industries – Firozabad | 500 kW Rooftop Solar Project",
    date: "10 May 2024",
    cardImage: FIROZABAD_GLASS_SHELL,
    heroImage: FIROZABAD_GLASS_SHELL,
    fullDescription:
      "Firozabad Glass Shell Industries’ facility in Firozabad is embracing renewable energy with the installation of a 500 kW rooftop solar power plant. This on-grid solar system is designed to provide reliable electricity, reduce operational energy costs, and lower the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, engineered for maximum sunlight exposure, durability, and long-term performance. Our team executed a complete turnkey solution, including design, engineering, supply, installation, and commissioning, resulting in a fully operational and efficient solar energy system.This project demonstrates Firozabad Glass Shell Industries’ commitment to sustainable industrial operations and green energy adoption.",

    solarSection: {
     titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Firozabad Glass Shell Industries",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 500 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "okay-glass-industries-firozabad",
    title: "Okay Glass Industries – Firozabad | 600 kW Rooftop Solar Project",
    date: "25 May 2024",
    cardImage: rooftop_ferozabad,
    heroImage: rooftop_ferozabad,
    fullDescription:
      "Okay Glass Industries’ facility in Firozabad is adopting clean, renewable energy with the installation of a 600 kW rooftop solar power plant. This on-grid solar system is designed to deliver reliable electricity, reduce operational energy costs, and lower the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, engineered for maximum sunlight exposure, long-term durability, and efficient performance. Our team provided a complete turnkey solution, including design, engineering, supply, installation, and commissioning, resulting in a fully operational and optimized solar energy system.This project underscores Okay Glass Industries’ commitment to sustainability and the adoption of green energy solutions in industrial operations.",

    solarSection: {
      titleLine1: "Join the Solar Revolution",
      titleLine2: "with Savorka",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Okay Glass Industries",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 600 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "durgesh-block-china-glass-works-firozabad",
    title: "Durgesh Block & China Glass Works Ltd – Firozabad | 1500 kW Rooftop Solar Project",
    date: "14 Jun 2024",
    cardImage: durges_1500,
    heroImage: durges_1500,
    fullDescription:
      "Durgesh Block & China Glass Works Ltd’s facility in Firozabad is moving towards sustainable energy with the installation of a 1,500 kW rooftop solar power plant. This on-grid solar system ensures reliable electricity, optimized energy costs, and a significant reduction in the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, designed for maximum sunlight exposure, durability, and long-term performance. Our team delivered a complete turnkey solution, including design, engineering, supply, installation, and commissioning, resulting in a fully operational and efficient solar energy system.This project highlights Durgesh Block & China Glass Works Ltd’s commitment to green energy and sustainable industrial operations.",

    solarSection: {
      titleLine1: "Mega Rooftop Solar",
      titleLine2: "for Heavy Industry",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: Durgesh Block & China Glass Works Ltd",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 1,500 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning",
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "general-traders-firozabad",
    title: "General Traders – Firozabad | 660 kW Rooftop Solar Project",
    date: "28 Jun 2024",
    cardImage: trader,
    heroImage: trader,
    fullDescription:
      "General Traders’ facility in Firozabad is adopting renewable energy with the installation of a 660 kW rooftop solar power plant. This on-grid solar system is designed to provide reliable electricity, reduce energy costs, and lower the facility’s carbon footprint.The solar panels are installed on a tin shade rooftop structure, engineered for optimal sunlight exposure, durability, and long-term performance. Our team delivered a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully functional and efficient solar energy system.This project reflects General Traders’ commitment to sustainability and green energy adoption in industrial operations.",

    solarSection: {
      titleLine1: "Commercial Solar Solutions",
      titleLine2: "for Daily Efficiency",
      coverLabel: "Project Specifications",
      coveragePoints: [
        "Client Name: General Traders",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 660 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "farukhi-glass-industries-firozabad",
    title: "Farukhi Glass Industries – Firozabad | 1500 kW Rooftop Solar Project",
    date: "11 Jul 2024",
    cardImage: firozabad_1500,
    heroImage: firozabad_1500,
    fullDescription:
      "Farukhi Glass Industries’ Firozabad facility is advancing towards sustainable energy with the installation of a 1,500 kW rooftop solar power plant. This on-grid solar system is designed to provide reliable electricity, optimize energy costs, and reduce the facility’s carbon footprint.The solar panels are mounted on a tin shade rooftop structure, engineered for maximum sunlight exposure, durability, and long-term performance. Our team executed a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power system.This project showcases Farukhi Glass Industries’ commitment to clean energy and sustainable industrial operations, reinforcing the adoption of renewable energy solutions in large-scale manufacturing facilities.",

    solarSection: {
      titleLine1: "Heavy Duty Solar Power",
      titleLine2: "with Savorka",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: Farukhi Glass Industries",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 1,500 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  {
    slug: "rgi-rise-glass-industries-firozabad",
    title: "RGI Rise Glass Industries – Firozabad | 1500 kW Rooftop Solar Project",
    date: "26 Jul 2024",
    cardImage: rgi,
    heroImage: rgi,
    fullDescription:
      "RGI Rise Glass Industries’ facility in Firozabad is set to harness renewable energy with the installation of a 1,500 kW rooftop solar power plant. This on-grid solar system is designed to deliver consistent, clean electricity while significantly reducing the facility’s carbon footprint and energy costs.The solar panels are installed on a tin shade rooftop structure, carefully engineered for maximum sunlight exposure, durability, and long-term performance. Our team provides a complete turnkey solution, covering design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar energy system.This project reflects RGI Rise Glass Industries’ commitment to sustainability and green energy, demonstrating the practical implementation of renewable solutions in industrial operations.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: RGI Rise Glass Industries",
        "Project Location: Firozabad, Uttar Pradesh",
        "Project Capacity: 1,500 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Tin Shade Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

  // {
  //   slug: "Adani-Agri-Fresh–Rampur-750-kW-Rooftop-Solar-Project",
  //   title: "Adani Agri Fresh – Rampur | 750 kW Rooftop Solar Project",
  //   date: "16 Dec 2025",
  //   cardImage: ground,
  //   heroImage: hero2,
  //   fullDescription:
  //     "Adani Agri Fresh’s Rampur facility in Himachal Pradesh is being powered sustainably through a 750 kW rooftop solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation uses a tin shade rooftop structure, engineered for optimal sunlight exposure, safety, and long-term durability. Our team provides a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power setup.This project exemplifies Adani Agri Fresh’s proactive approach to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

  //   solarSection: {
  //     titleLine1: "High Capacity Solar",
  //     titleLine2: "for Industrial Growth",
  //     coverLabel: "Project highlights",
  //     coveragePoints: [
  //       "Client Name: Adani Agri Fresh",
  //       "Project Location: Rampur, Himachal Pradesh",
  //       "Project Capacity: 750 kW",
  //       "Installation Type: Rooftop Solar Power Plant",
  //       "Mounting Structure: Tin Shade Rooftop Structure",
  //       "System Type: On-Grid Solar System",
  //       "Project Status: Ongoing",
  //       "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
  //     ],
  //     yearsText: "9+ YEARS",
  //     experienceText: "Experience",
  //     mainImage: mainImg,
  //     smallImage: smallImg
  //   }
  // },


 



  {
    slug: "KCC-OND-Baroda-Mev-3.528MWp-Ground-Mounted-Solar-Project",
    title: "KCC - Baroda Mev-3.528 MWp || Ground Mounted Solar Project",
    date: "16 Dec 2025",
    cardImage: Manyapura,
    heroImage: Manyapura,
    fullDescription:
      "KCC's Baroda Mev facility is being powered sustainably through a 3.528 MWp ground-mounted solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation utilizes a robust ground-mounted structure, engineered for optimal sunlight exposure, safety, and long-term durability. Our team delivers a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power setup.This project reflects KCC’s strong commitment to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: KCC-OND-Baroda-Mev",
        "Project Location: Baroda Mev",
        "Project Capacity: 3.528 MWp",
        "Installation Type: Ground-Mounted Solar Power Plant",
        "Mounting Structure: Robust Ground-Mounted Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },



    {
    slug: "Rohru-Shimla-800-kW-Rooftop-Solar-Project",
    title: "Rohru, Shimla - 800 kW || Rooftop Solar Project",
    date: "16 Dec 2025",
    cardImage: Rohru,
    heroImage: Rohru,
    fullDescription:
      "Rohru, Shimla facility is being powered sustainably through an 800 kW rooftop solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation utilizes a robust rooftop structure, engineered for optimal sunlight exposure, safety, and long-term durability. Our team delivers a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power setup.This project reflects the client’s strong commitment to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: Rooftop Solar",
        "Project Location: Rohru, Shimla",
        "Project Capacity: 800 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Robust Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  },

   {
    slug: "Sainj-Shimla-550-kW-Rooftop-Solar-Project",
    title: "Sainj, Shimla - 550 kW || Rooftop Solar Project",
    date: "16 Dec 2025",
    cardImage: Sainj,
    heroImage: Sainj,
    fullDescription:
      "KCC's Sainj, Shimla facility is being powered sustainably through a 550 kW rooftop solar power plant. This on-grid solar system is designed to generate reliable electricity while reducing the facility’s carbon footprint, supporting the client’s commitment to renewable energy.The solar installation utilizes a durable rooftop mounting structure, engineered for optimal sunlight exposure, safety, and long-term performance. Our team provides a complete turnkey solution, including design, engineering, supply, installation, and commissioning, ensuring a fully operational and efficient solar power system.This project highlights KCC’s commitment to sustainability and energy efficiency, delivering measurable environmental and operational benefits.",

    solarSection: {
      titleLine1: "High Capacity Solar",
      titleLine2: "for Industrial Growth",
      coverLabel: "Project highlights",
      coveragePoints: [
        "Client Name: Rooftop",
        "Project Location: Sainj, Shimla",
        "Project Capacity: 550 kW",
        "Installation Type: Rooftop Solar Power Plant",
        "Mounting Structure: Robust Rooftop Structure",
        "System Type: On-Grid Solar System",
        "Project Status: Ongoing",
        "Execution Scope: Design, Engineering, Supply, Installation & Commissioning"
      ],
      yearsText: "9+ YEARS",
      experienceText: "Experience",
      mainImage: mainImg,
      smallImage: smallImg
    }
  }



  
];

export default projectsData;